import { render } from "./StickyButton.vue?vue&type=template&id=521ddfee"
const script = {}

import "./StickyButton.vue?vue&type=style&index=0&id=521ddfee&lang=scss"

import exportComponent from "/Users/gray/Desktop/Work_temp/經貿網/web/project/rotate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__